<app-modal-panel #modalPanel headerTitle="Add Document" buttonTitle="Add Document" [allowSubmit]="name && url && !!uploadFile && !!publicationDate" (submit)="onAddDocument()">
  <div class="content">
    <div class="modal-body pt-0 pb-0">
      <div class="modal-content border-0">
        <div class="row mb-2">
          <div class="col-sm-12 mb-1">
            <button type="button" class="btn border-0 blue" (click)="file.click()">
              <span>UPLOAD FILE</span>
            </button>
            <input type="file" #file (change)="onSelectFile($event)" />
            <a *ngIf="isVideoFile" (click)="removeFile()">Remove selected file</a>
          </div>
        </div>
        <br>
        <div class="row mb-4" *ngIf="!isVideoFile">
          <div class="col-sm-12">
            <input inputFocus name="url" class="form-control border-0" type="text"
              [(ngModel)]="url" placeholder="url://" required>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 mb-1">
            <span class='title'>Display Name*</span>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <input inputFocus name="name" class="form-control border-0" type="text"
              [(ngModel)]="name" [attr.placeholder]="'Display Name*'" required>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 mt-3 mb-1">
            <span class='title'>Publication Date*</span>
          </div>
        </div>
        <div class="row">
          <div class=	"col-sm-7">
            <app-date-picker name="publicationDate" [(ngModel)]="publicationDate" [allowNow]="true" required></app-date-picker>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 mt-3 mb-1">
            <div class="note">Please note that only the following document formats are supported: PDF, doc, docx, txt, jpg, jpeg, gif, png, mp4, mov. Each doc must not exceed XX MB</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</app-modal-panel>
